import {createContext} from 'react'

interface PartnerEditShowContextProps {
  idProceso: string
  setIdProceso: (value: string) => void
  showKitDocumentoModal: boolean
  setShowKitDocumentoModal: (value: boolean) => void
}

const PartnerEditShowContext = createContext<PartnerEditShowContextProps>({
  idProceso: '',
  setIdProceso: (value) => {},
  showKitDocumentoModal: false,
  setShowKitDocumentoModal: (value) => {},
})

export {PartnerEditShowContext}
